module.exports = __webpack_public_path__ + "img/26aa9388a393cb92699cda45e653ad53.png";